import { useEffect, useState } from "react";

const DELAY = 300;

export const useDelayUnmount = (isMounted: boolean) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    let timeoutId: number;

    if (isMounted && !shouldRender) {
      setShouldRender(true);
    } else if (!isMounted && shouldRender) {
      timeoutId = window.setTimeout(() => setShouldRender(false), DELAY);
    }

    return () => clearTimeout(timeoutId);
  }, [isMounted, shouldRender]);

  return shouldRender;
};
